import { apiClient } from './api';

export type AvailabilityStatus = 'attends' | 'supports';

export interface ShiftArea {
  id: number;
  name: string;
  karma: number | null;
  blockedWeekdays: string[];
}

export interface ShiftRegistration {
  volunteerId: string;
  displayName: string;
  status: AvailabilityStatus;
}

export interface ShiftSlot {
  id: string | null;
  date: string;
  areaId: number;
  display: boolean;
  placeholderCount: number;
  placeholderNames: string[];
  registrations: ShiftRegistration[];
}

export interface UpdateShiftSlot {
  display?: boolean;
  placeholderCount?: number;
  placeholderNames?: string[];
}

export type UpcomingShiftStatus = 'ATTENDS' | 'SUPPORTS';

export interface UpcomingShiftRegistration {
  volunteerId: string;
  slotId: string;
  status: UpcomingShiftStatus;
  updatedAt: string;
  slot: {
    id: string;
    date: string;
    areaId: number;
    display: boolean;
    placeholderCount: number;
    placeholderNames: string[];
    area: {
      id: number;
      name: string;
      blockedWeekdays: string[];
    };
  };
}

export const shiftApi = {
  getAreas: async (): Promise<ShiftArea[]> => {
    const response = await apiClient.get<ShiftArea[]>('/shift/areas');
    return response.data;
  },

  getSlots: async (
    areaId: number,
    start: string,
    end: string
  ): Promise<ShiftSlot[]> => {
    const response = await apiClient.get<ShiftSlot[]>('/shift/slots', {
      params: { areaId, start, end },
    });
    return response.data;
  },

  getMyUpcomingShifts: async (): Promise<UpcomingShiftRegistration[]> => {
    const response = await apiClient.get<UpcomingShiftRegistration[]>(
      '/shift/registrations/latest'
    );
    return response.data;
  },

  register: async ({
    areaId,
    date,
  }: {
    areaId: number;
    date: string;
  }): Promise<void> => {
    await apiClient.put(`/shift/areas/${areaId}/slots/${date}/availability`);
  },

  cancel: async ({
    areaId,
    date,
  }: {
    areaId: number;
    date: string;
  }): Promise<void> => {
    await apiClient.delete(`/shift/areas/${areaId}/slots/${date}/availability`);
  },

  updateSlot: async (
    areaId: number,
    date: string,
    update: UpdateShiftSlot
  ): Promise<void> => {
    await apiClient.patch(`/shift/areas/${areaId}/slots/${date}`, update);
  },

  adminDeleteRegistration: async (
    areaId: number,
    date: string,
    volunteerId: string
  ): Promise<void> => {
    await apiClient.delete(
      `/shift/areas/${areaId}/slots/${date}/availability/${volunteerId}`
    );
  },
};
